import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
	return twMerge(clsx(inputs));
}

export function formatCurrency(value) {
  return new Intl.NumberFormat('es-ES', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
  }).format(value);
}

// Función para limpiar y validar datos JSON problemáticos
export const sanitizeJsonData = (data) => {
  if (!data) return data;
  
  try {
    // Si es una cadena, intentar parsearla
    if (typeof data === 'string') {
      return JSON.parse(data);
    }
    
    // Si es un objeto, validar que sea JSON válido
    if (typeof data === 'object') {
      // Verificar si hay cadenas muy largas que puedan causar problemas
      const sanitized = JSON.parse(JSON.stringify(data));
      return sanitized;
    }
    
    return data;
  } catch (error) {
    console.warn('Error sanitizing JSON data:', error);
    return null;
  }
};

// Función para limpiar URLs de imágenes
export const sanitizeImageUrl = (url) => {
  if (!url || typeof url !== 'string') return null;
  
  try {
    // Verificar que la URL sea válida
    new URL(url);
    return url;
  } catch (error) {
    console.warn('Invalid image URL:', url);
    return null;
  }
};

// Función para validar y limpiar datos de productos
export const sanitizeProductData = (product) => {
  if (!product) return product;
  
  try {
    const sanitized = { ...product };
    
    // Limpiar campo images si existe
    if (sanitized.images) {
      try {
        if (typeof sanitized.images === 'string') {
          sanitized.images = JSON.parse(sanitized.images);
        }
        
        // Validar que images sea un array
        if (Array.isArray(sanitized.images)) {
          sanitized.images = sanitized.images
            .map(url => sanitizeImageUrl(url))
            .filter(url => url !== null);
        } else {
          sanitized.images = [];
        }
      } catch (error) {
        console.warn('Error sanitizing product images:', error);
        sanitized.images = [];
      }
    }
    
    // Limpiar otros campos JSON
    if (sanitized.sizes && typeof sanitized.sizes === 'string') {
      try {
        sanitized.sizes = JSON.parse(sanitized.sizes);
      } catch (error) {
        sanitized.sizes = [];
      }
    }
    
    if (sanitized.colors && typeof sanitized.colors === 'string') {
      try {
        sanitized.colors = JSON.parse(sanitized.colors);
      } catch (error) {
        sanitized.colors = [];
      }
    }
    
    return sanitized;
  } catch (error) {
    console.warn('Error sanitizing product data:', error);
    return product;
  }
};

// Función para validar y limpiar datos de inventario
export const sanitizeInventoryData = (inventory) => {
  if (!inventory) return inventory;
  
  try {
    if (Array.isArray(inventory)) {
      return inventory.map(item => {
        const sanitized = { ...item };
        
        // Asegurar que quantity y pending_orders sean números
        sanitized.quantity = parseInt(sanitized.quantity) || 0;
        sanitized.pending_orders = parseInt(sanitized.pending_orders) || 0;
        
        return sanitized;
      });
    }
    
    return inventory;
  } catch (error) {
    console.warn('Error sanitizing inventory data:', error);
    return inventory;
  }
};
